import { render, staticRenderFns } from "./BaseTemplateSuccess.vue?vue&type=template&id=c405c72e&scoped=true"
import script from "./BaseTemplateSuccess.vue?vue&type=script&lang=js"
export * from "./BaseTemplateSuccess.vue?vue&type=script&lang=js"
import style0 from "./BaseTemplateSuccess.vue?vue&type=style&index=0&id=c405c72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405c72e",
  null
  
)

export default component.exports